module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Complaints/complaints.component.css
// module id = ./src/app/Complaints/complaints.component.css
// module chunks = main